import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/invitationRespond';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { invitationId, verb } = action.payload;
  try {
    yield call(
      axios.post,
      `${config.API_URL}/organization/invitations/${invitationId}/${verb}`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ verb }));
  } catch (err) {
    yield put(ErrorAction(err));
    yield put(fetchFailure(
      err?.response?.data?.data?.message
        || err?.response?.data?.message
        || `Could not ${verb} the invitation.`,
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
